function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_6598_86534)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7148 33.4478L11.796 26.1645L4.5127 22.2458L7.32311 19.4749L13.0627 20.4645L17.1002 16.427L4.55228 11.0833L7.87728 7.67909L23.1169 10.3708L28.0252 5.46242C28.6321 4.85547 29.3842 4.552 30.2814 4.552C31.1787 4.552 31.9308 4.85547 32.5377 5.46242C33.1446 6.06936 33.4481 6.81485 33.4481 7.69888C33.4481 8.5829 33.1446 9.32839 32.5377 9.93534L27.5898 14.8833L30.2814 30.0833L26.9169 33.4478L21.5335 20.8999L17.496 24.9374L18.5252 30.6374L15.7148 33.4478Z"
}));

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "#D9D9D9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6598_86534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.afaed65a.svg";
export { ForwardRef as ReactComponent };